import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        step: '=',
        setStep: '&',
        update: '&'
    },
    template: `
    <form enctype='multipart/form-data'>
        <div class="modal-body">
            <modals-question-import-steps step="vm.step"/>
            <div ng-if="vm.uploadForm.questionType === vm.QUESTIONS_TYPE_ENUM.KEYS.CHECKBOX" class="alert alert-notify">
                {{ "question.Points value of '-1' points will be assigned to all false answers automatically" | translate }}
            </div>
            <div class="form">
                <div class="row">
                    <label class="label">{{ 'question.File' | translate }}</label>
                    <div class="items">
                        <input ngf-select="vm.setFile($file)" ng-model="vm.uploadForm.file" type="file" accept=".csv">
                    </div>
                </div>
                <div class="row">
                  <label class="label">{{ 'question.Language' | translate }}</label>
                  <div class="items">
                    <select class="form-control"
                            ng-model="vm.uploadForm.language"
                            ng-options="code as vm.COMPANY_LANGUAGE_ENUM.LABELS[code]
                                        for code in vm.TokenService.getCompanySupportedLanguages()
                                        track by code">
                      <option value=""></option>
                    </select>
                  </div>
                </div>
                <div class="row">
                  <label class="label">{{ 'question.Question type' | translate }}</label>
                  <div class="items">
                    <select class="form-control"
                            ng-model="vm.uploadForm.questionType"
                            ng-change="vm.changeQuestionType()"
                            ng-options="type as label for (type, label) in vm.QUESTIONS_TYPE_ENUM.IMPORT_ALLOWED_LABELS track by type">
                      <option value=""></option>
                    </select>
                  </div>
                </div>
                <div class="row">
                    <label class="label">{{ 'question.Delimiter' | translate }}</label>
                    <div class="items">
                        <select class="min form-control" ng-model="vm.uploadForm.delimitter">
                            <option ng-if="vm.uploadForm.questionType !== vm.QUESTIONS_TYPE_ENUM.KEYS.CHECKBOX"></option>
                            <option value=";">;</option>
                            <option ng-if="vm.uploadForm.questionType !== vm.QUESTIONS_TYPE_ENUM.KEYS.CHECKBOX" value=",">,</option>
                        </select>
                        <p class="desc">{{ 'question.If empty then "auto detect"' | translate }}</p>
                    </div>
                </div>
                <div class="row">
                    <label class="label">{{ 'question.Encoding' | translate }}</label>
                    <div class="items">
                        <select class="form-control" ng-model="vm.uploadForm.encoding">
                            <option></option>
                            <option value="ascii">{{ 'question.Excel CSV-default (ASCII)' | translate }}</option>
                            <option value="UTF-8">{{ 'question.UTF-8' | translate }}</option>
                        </select>
                        <p class="desc">{{ 'question.If empty then "auto detect"' | translate }}</p>
                    </div>
                </div>
                <div class="row">
                    <span class="label">{{ 'question.Add to pool' | translate }}</span>
                    <div class="items">
                        <ul class="checkboxes">
                            <li><label><input type="checkbox" ng-model="vm.addToPool"> {{ 'question.Yes' | translate }}</label></li>
                        </ul>
                    </div>
                </div>
                <div class="row" ng-if="vm.addToPool">
                  <label class="label">{{ 'question.Pools' | translate }}</label>
                  <div class="items">
                    <select class="form-control"
                            ng-model="vm.uploadForm.questionPoolId"
                            ng-options="pool.id as pool.name for pool in vm.questionPools track by pool.id">
                      <option value=""></option>
                    </select>
                  </div>
                </div>
            </div>
        </div>
        <div class="modal-footer" >
            <ul class="actions01">
                <li class="primary"><button class="btn main" type="button" ng-click="vm.upload()">{{ 'general.Import' | translate }}</button></li>
                <li><button class="btn discrete" type="button" ng-click="vm.update()">{{ 'general.Cancel' | translate }}</button></li>
            </ul>
        </div>
    </form>
    `
})
export default class {
    constructor ($translate, toastr, $timeout, QuestionImportService, TokenService,
                 COMPANY_LANGUAGE_ENUM, QUESTIONS_TYPE_ENUM, FORMS_POOL_ENUM, QuestionPoolResource) {
        this.QuestionImportService = QuestionImportService;
        this.TokenService = TokenService;
        this.$timeout = $timeout;
        this.$translate = $translate;
        this.toastr = toastr;
        this.COMPANY_LANGUAGE_ENUM = COMPANY_LANGUAGE_ENUM;
        this.FORMS_POOL_ENUM = FORMS_POOL_ENUM;
        this.QuestionPoolResource = QuestionPoolResource;
        this.addToPool = false;
        this.QUESTIONS_TYPE_ENUM = QUESTIONS_TYPE_ENUM;
    }

    $onInit () {
        this.uploadForm = {
            delimitter: this.QuestionImportService.delimitter,
            encoding: this.QuestionImportService.encoding,
            questionPoolId: this.QuestionImportService.questionPoolId
        };

        this.QuestionPoolResource.query({ status: this.FORMS_POOL_ENUM.KEYS.ACTIVE, pageSize: 0 }).$promise.then((response) => {
            this.questionPools = response;
        });

        this.QuestionImportService.setCompanyMetaFields();
    }

    upload () {
        if (!this.uploadForm.file || this.uploadForm.file.name.split('.').slice(-1).pop() !== 'csv') {
            this.toastr.error(this.$translate.instant('question.Please add csv to import'));
        }
        else if (this.uploadForm.delimitter === ',' && this.uploadForm.questionType === this.QUESTIONS_TYPE_ENUM.KEYS.CHECKBOX) {
            this.toastr.error(this.$translate.instant('question.Only delimiter \';\' is allowed with Checkbox questionst'));
        }
        else {
            let language = this.uploadForm.language;
            if (!language) {
                language = this.TokenService.getCompanyLanguage(false);
            }
            this.QuestionImportService.setEncoding(this.uploadForm.encoding);
            this.QuestionImportService.setDelimitter(this.uploadForm.delimitter);
            this.QuestionImportService.setLanguage(language);
            this.QuestionImportService.setQuestionType(this.uploadForm.questionType);

            if (!this.addToPool) {
                this.uploadForm.questionPoolId = null;
            }
            this.QuestionImportService.setQuestionPoolId(this.uploadForm.questionPoolId);

            this.QuestionImportService.parse(this.uploadForm.file).then(() => {
                // scope problem here, timeout resolves this
                this.$timeout(() => this.setStep({ step: 2 }));
            });
        }
    }

    setFile (file) {
        this.uploadForm.file = file;
    }

    changeQuestionType () {
        // in case of checkbox selected reset ',' delimiter
        if (this.uploadForm.questionType === this.QUESTIONS_TYPE_ENUM.KEYS.CHECKBOX) {
            this.uploadForm.delimitter = ';';
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/question/import/file/index.js